import { Modal, Box } from "@mui/material";
import SecondaryBtn from "../Buttons/SecondaryBtn";
import PrimaryBtn from "../Buttons/PrimaryBtn";
import { CrossIcon, StorageIcon } from "../FileRepo/Icons";

const CustomModal = ({
  isHeader = true,
  open,
  onClose,
  title = "",
  children,
  primaryLabel = null,
  primaryClick = null,
  secondaryLabel = null,
  secondaryClick = null,
  justifyFooter = "flex-end",
  width = 600,
  height = null,
  primaryDisbaled = false,
  childMT = 4,
  storage = null,
}) => {
  return (
    <Modal
      keepMounted
      open={open}
      // onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          //   width: width,
          bgcolor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          p: {
            xs: 2,
            sm: 3,
            md: 4,
          },
          outline: "none",
          // maxHeight: { height },
          ...(height && { maxHeight: height }),
          overflow: "auto",
          width: {
            xs: "90%", // mobile
            sm: "80%", // tablets
            md: width, // desktop fallback
          },
          maxWidth: "95vw",
        }}
      >
        {/* Header */}
        {isHeader && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            {storage !== null ? (
              <div className="flex items-center">
                <div
                  role="heading"
                  aria-level="1"
                  title={title}
                  className="text-[#232323] font-medium text-base break-words max-w-[95%]"
                >
                  {title}
                </div>
            <div className="w-px self-stretch bg-[#D9D9D9] mx-2" />

                <div className = "flex items-center gap-2">
                  <StorageIcon />
                  <span className = "text-[#555555] font-medium text-[0.85rem]">{storage?.toFixed(2)}% Storage Used </span>
                </div>
              </div>
            ) : (
              <div
                role="heading"
                aria-level="1"
                title={title}
                className="text-[#232323] font-medium text-base break-words max-w-[95%]"
              >
                {title}
              </div>
            )}
            <button onClick={onClose} className="closebtn">
              <CrossIcon />
            </button>
          </Box>
        )}

        {/* Content */}
        <Box mt={childMT}>{children}</Box>

        {/* Footer Buttons */}
        {(secondaryLabel || primaryLabel) && (
          <Box
            mt={4}
            display="flex"
            justifyContent={justifyFooter}
            gap={2}
            width={"100%"}
          >
            {secondaryLabel && (
              <SecondaryBtn handleClick={secondaryClick} label={secondaryLabel}>
                {secondaryLabel}
              </SecondaryBtn>
            )}
            {primaryLabel && (
              <PrimaryBtn
                label={primaryLabel}
                disabled={primaryDisbaled}
                handleClick={primaryClick}
              />
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default CustomModal;
